// Modules
import styled from 'styled-components';

// Web Components
import { BiuButton } from '../../biu-web-components/src/components';

// Types
import { styledComponentProps } from '../../types/theme';

export const LoadMoreBtn = styled(BiuButton)`
	margin: 40px 0;

    .biu-button {
        background-color:${({ theme }: styledComponentProps): string =>
        theme.colors.ui.lightBlue}77;
        border: none;
        .biu-button__highlight {
            background-color: transparent;
        }
    }

	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.sm} {
	
        .biu-button {
            width: unset;
            margin: 40px 30px;
        }
	}
`;
